import { useContext, useEffect, useState } from "react";
import UIContext from "../../../contexts/ui/UIContext";
import Loading from "../../ui-elements/Loading";
import ProcessContext from "../../../contexts/process/ProcessContext";
import SeedVariantTypeCard from "../../seed-type-management/SeedVariantTypeCard";
import BackButton from "../../layout/BackButton";
import AuthContext from "../../../contexts/auth/AuthContext";
import ConfirmDeleteModal from "../../management/seedTypes/ConfirmDeleteModal";

const SeedVariantTypeSelection = ({ backwardTo, seedTypeId }) => {
  const { continueProcess, activeProcessId, backIsAllowed } =
    useContext(ProcessContext);
  const { accessibleSeedTypes } = useContext(AuthContext);
  const { loading, setInfo } = useContext(UIContext);

  const [seedType, setSeedType] = useState(null);
  const [selectedVariantPendingConfirmation,setSelectedVariantPendingConfirmation,] = useState(null);
  const [isShortageModalOpen, setIsShortageModalOpen] = useState(false);
  useEffect(() => {
    setInfo("PLEASE SELECT SEED VARIANT");
  }, []);

  useEffect(() => {
    if (seedTypeId) {
      const selectedSeedType = accessibleSeedTypes?.find(
        (st) => st.id == seedTypeId
      );
      setSeedType(selectedSeedType);
    }
  }, [seedTypeId, accessibleSeedTypes]);

  const getAvailableSeeds = (variant) => {
    const rawAvailable =variant?.availableSeeds ?? variant?.stock ?? variant?.count ?? 0;
  
    const parsed = typeof rawAvailable === 'string'? Number(rawAvailable.trim()) : Number(rawAvailable);
  
    if (!Number.isFinite(parsed)) 
    {
      return 0;
    }
    return Math.max(0, Math.floor(parsed));
  };
  const handlePickVariant = async (variant) => {
    try {
      const available = getAvailableSeeds(variant);
      if (available <= 0) {
        setSelectedVariantPendingConfirmation(variant);
        setIsShortageModalOpen(true);
        return;
      }
      await continueProcess(activeProcessId, variant?.id);
    } catch (error) {
      console.error(error);
    }
  };
  const handleConfirmShortage = async () => {
    try {
      if (selectedVariantPendingConfirmation) {
        const v = selectedVariantPendingConfirmation;
        setIsShortageModalOpen(false);
        setSelectedVariantPendingConfirmation(null);
        await continueProcess(activeProcessId, v?.id);
      } else {
        setIsShortageModalOpen(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleCancelShortage = () => {
    setIsShortageModalOpen(false);
    setSelectedVariantPendingConfirmation(null);
  };

  return loading ? (
    <Loading fullScreen />
  ) : (
    <div className="seed-variant-type-selection-container">
      <ConfirmDeleteModal
        show={isShortageModalOpen}
        onConfirm={handleConfirmShortage}
        onCancel={handleCancelShortage}
        header={"Not enough seeds available"}
        message={
          selectedVariantPendingConfirmation
            ? "There may be not enough seeds to seed. Do you want to proceed?"
            : null
        }
        confirmLabel="Continue"
        cancelLabel="Cancel"
      />

      <div className="seed-variant-type-selection-content">
        {seedType?.seedVariantTypes?.map((variant) => (
          <SeedVariantTypeCard
            key={variant.id}
            seedType={seedType}
            seedVariantType={variant}
            clickHandler={() => handlePickVariant(variant)}
          />
        ))}
      </div>
      <BackButton disabled={!backIsAllowed} navigateTo={backwardTo} />
    </div>
  );
};

export default SeedVariantTypeSelection;
